import { useRoutesContext } from '@src/app/context/Routes/Routes';
import { User } from '@src/entities/User/ui/components/User';
import { ErrorHandler } from '@src/shared/ui/components/ErrorHandler';
import { useAssets } from '@src/shared/ui/hooks/useAssets';
import { useFormFieldArray } from '@uhg-abyss/web/hooks/useFormFieldArray';
import { Flex } from '@uhg-abyss/web/ui/Flex';
import { Grid } from '@uhg-abyss/web/ui/Grid';
import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { Link } from '@uhg-abyss/web/ui/Link';
import React from 'react';

import { Table } from './components/Table';
import { Styles } from './includes/styles';

/**
 * Filters
 *
 * @TODO Needs description.
 *
 * @param filterKey
 * @param form
 * @param headerLeft
 * @param isDisabled
 * @param permissions
 * @returns {Element}
 * @constructor
 */
export function Filters({
  filterKey = 'filters',
  form = {
    control: {},
    setValue: () => {},
  },
  headerLeft = null,
  isDisabled = false,
  permissions = {
    add: {
      attributes: [],
      isAllowed: null,
      resource: '',
    },
    edit: {
      attributes: [],
      isAllowed: null,
      resource: '',
    },
    remove: {
      attributes: [],
      isAllowed: null,
      resource: '',
    },
  },
}) {
  const { assets, isLoadingAssets } = useAssets([
    {
      apiKey: 'Action',
      queryKey: 'ListActionStatuses',
    },
    {
      apiKey: 'Tag',
      queryKey: 'ListTags',
    },
    {
      apiKey: 'ActionPath',
      payload: { page: 0, size: 9999, sort: 'name,asc', statusList: ['ACTIVE'] },
      queryKey: 'ListActionPaths',
    },
  ]);

  const { currentRoute } = useRoutesContext();

  const { append, fields, remove, replace } = useFormFieldArray({
    control: form.control,
    name: filterKey,
  });

  /**
   * handleReset
   *
   * Resets the user specified filters from the data table.
   *
   * @returns {Promise<void>}
   */
  const handleReset = () => {
    form.setValue(filterKey, []);
    replace([]);
  };

  return (
    <ErrorHandler location="src/entities/Criteria/ui/components/Filters/Filters.jsx">
      <Styles>
        <Grid>
          <Grid.Col span={{ xs: '50%' }}>
            <Flex
              alignContent="flex-start"
              alignItems="flex-end"
              className="topRow"
              direction="row"
              justify="flex-start"
            >
              {headerLeft}
            </Flex>
          </Grid.Col>
          <Grid.Col css={{ paddingBottom: 0 }} span={{ xs: '50%' }}>
            <Layout.Group alignItems="bottom" alignLayout="right" css={{ height: '100%' }}>
              <User.Capability
                alias="add"
                attributes={permissions?.add?.attributes}
                isAllowed={permissions?.add?.isAllowed}
                resource={permissions?.add?.resource}
              >
                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                <Link
                  className={isDisabled ? 'isDisabled-true' : ''}
                  css={{ height: '100%' }}
                  id="addField"
                  isDisabled={isDisabled}
                  onClick={() => {
                    append({ column: '', condition: '', value: '' });
                  }}
                  variant="custom"
                >
                  <Flex alignItems="center" css={{ height: '100%' }}>
                    <div>
                      <IconSymbol icon="add_circle" variant="filled" />
                      <IconSymbol icon="add_circle" variant="outlined" />
                    </div>
                    <div>Add Filter</div>
                  </Flex>
                </Link>
              </User.Capability>
            </Layout.Group>
          </Grid.Col>
          <Grid.Col css={{ paddingTop: 0 }} span={{ xs: '100%' }}>
            <Table
              {...{
                append,
                assets,
                dataKey: `${currentRoute?.slug}-filters`,
                fields,
                filterKey,
                form,
                handleReset,
                isDisabled,
                isLoading: isLoadingAssets,
                permissions,
                remove,
                replace,
              }}
            />
          </Grid.Col>
        </Grid>
      </Styles>
    </ErrorHandler>
  );
}
